// Subset of list of locales defined by CLDR
// based on https://github.com/umpirsky/locale-list
angular.module('platformWebApp')
.factory('platformWebApp.common.locales', function () {
    return {
        get: function (id) {
            return _.findWhere(this.query(), { id: this.normalize(id) });
        },
        contains: function (id) {
            return _.map(this.query(), function (entry) { return entry.id }).includes(this.normalize(id));
        },
        normalize: function(id) {
            var result = undefined;
            if (!!id) {
                var parts = id.split(/[-_]/g);
                parts[0] = parts[0].toLowerCase();
                if (parts.length > 1) {
                    parts[1] = parts[1].length === 2 ? parts[1].toUpperCase() : parts[1].capitalize();
                }
                if (parts.length > 2) {
                    parts[2] = parts[2].toUpperCase();
                }
                result = parts.join('_');
            }
            return result;
        },
        query: function () {
            return [
    { id: "af", name: "Afrikaans", nativeName: "Afrikaans" },
    { id: "af_NA", name: "Afrikaans (Namibia)", nativeName: "Afrikaans (Namibië)" },
    { id: "af_ZA", name: "Afrikaans (South Africa)", nativeName: "Afrikaans (Suid-Afrika)" },
    { id: "ak", name: "Akan", nativeName: "Akan" },
    { id: "ak_GH", name: "Akan (Ghana)", nativeName: "Akan (Gaana)" },
    { id: "sq", name: "Albanian", nativeName: "shqip" },
    { id: "sq_AL", name: "Albanian (Albania)", nativeName: "shqip (Shqipëri)" },
    { id: "sq_XK", name: "Albanian (Kosovo)", nativeName: "shqip (Kosovë)" },
    { id: "sq_MK", name: "Albanian (Macedonia)", nativeName: "shqip (Maqedoni)" },
    { id: "am", name: "Amharic", nativeName: "አማርኛ" },
    { id: "am_ET", name: "Amharic (Ethiopia)", nativeName: "አማርኛ (ኢትዮጵያ)" },
    { id: "ar", name: "Arabic", nativeName: "العربية" },
    { id: "ar_DZ", name: "Arabic (Algeria)", nativeName: "العربية (الجزائر)" },
    { id: "ar_BH", name: "Arabic (Bahrain)", nativeName: "العربية (البحرين)" },
    { id: "ar_TD", name: "Arabic (Chad)", nativeName: "العربية (تشاد)" },
    { id: "ar_KM", name: "Arabic (Comoros)", nativeName: "العربية (جزر القمر)" },
    { id: "ar_DJ", name: "Arabic (Djibouti)", nativeName: "العربية (جيبوتي)" },
    { id: "ar_EG", name: "Arabic (Egypt)", nativeName: "العربية (مصر)" },
    { id: "ar_ER", name: "Arabic (Eritrea)", nativeName: "العربية (أريتريا)" },
    { id: "ar_IQ", name: "Arabic (Iraq)", nativeName: "العربية (العراق)" },
    { id: "ar_IL", name: "Arabic (Israel)", nativeName: "العربية (إسرائيل)" },
    { id: "ar_JO", name: "Arabic (Jordan)", nativeName: "العربية (الأردن)" },
    { id: "ar_KW", name: "Arabic (Kuwait)", nativeName: "العربية (الكويت)" },
    { id: "ar_LB", name: "Arabic (Lebanon)", nativeName: "العربية (لبنان)" },
    { id: "ar_LY", name: "Arabic (Libya)", nativeName: "العربية (ليبيا)" },
    { id: "ar_MR", name: "Arabic (Mauritania)", nativeName: "العربية (موريتانيا)" },
    { id: "ar_MA", name: "Arabic (Morocco)", nativeName: "العربية (المغرب)" },
    { id: "ar_OM", name: "Arabic (Oman)", nativeName: "العربية (عُمان)" },
    { id: "ar_PS", name: "Arabic (Palestinian Territories)", nativeName: "العربية (الأراضي الفلسطينية)" },
    { id: "ar_QA", name: "Arabic (Qatar)", nativeName: "العربية (قطر)" },
    { id: "ar_SA", name: "Arabic (Saudi Arabia)", nativeName: "العربية (المملكة العربية السعودية)" },
    { id: "ar_SO", name: "Arabic (Somalia)", nativeName: "العربية (الصومال)" },
    { id: "ar_SS", name: "Arabic (South Sudan)", nativeName: "العربية (جنوب السودان)" },
    { id: "ar_SD", name: "Arabic (Sudan)", nativeName: "العربية (السودان)" },
    { id: "ar_SY", name: "Arabic (Syria)", nativeName: "العربية (سوريا)" },
    { id: "ar_TN", name: "Arabic (Tunisia)", nativeName: "العربية (تونس)" },
    { id: "ar_AE", name: "Arabic (United Arab Emirates)", nativeName: "العربية (الإمارات العربية المتحدة)" },
    { id: "ar_EH", name: "Arabic (Western Sahara)", nativeName: "العربية (الصحراء الغربية)" },
    { id: "ar_YE", name: "Arabic (Yemen)", nativeName: "العربية (اليمن)" },
    { id: "hy", name: "Armenian", nativeName: "հայերեն" },
    { id: "hy_AM", name: "Armenian (Armenia)", nativeName: "հայերեն (Հայաստան)" },
    { id: "as", name: "Assamese", nativeName: "অসমীয়া" },
    { id: "as_IN", name: "Assamese (India)", nativeName: "অসমীয়া (ভাৰত)" },
    { id: "az", name: "Azerbaijani", nativeName: "azərbaycan" },
    { id: "az_AZ", name: "Azerbaijani (Azerbaijan)", nativeName: "azərbaycan (Azərbaycan)" },
    { id: "az_Cyrl_AZ", name: "Azerbaijani (Cyrillic, Azerbaijan)", nativeName: "Азәрбајҹан (kiril, Азәрбајҹан)" },
    { id: "az_Cyrl", name: "Azerbaijani (Cyrillic)", nativeName: "Азәрбајҹан (kiril)" },
    { id: "az_Latn_AZ", name: "Azerbaijani (Latin, Azerbaijan)", nativeName: "azərbaycan (latın, Azərbaycan)" },
    { id: "az_Latn", name: "Azerbaijani (Latin)", nativeName: "azərbaycan (latın)" },
    { id: "bm", name: "Bambara", nativeName: "bamanakan" },
    { id: "bm_Latn_ML", name: "Bambara (Latin, Mali)", nativeName: "Bambara (Latin, Mali)" },
    { id: "bm_Latn", name: "Bambara (Latin)", nativeName: "Bambara (Latin)" },
    { id: "eu", name: "Basque", nativeName: "euskara" },
    { id: "eu_ES", name: "Basque (Spain)", nativeName: "euskara (Espainia)" },
    { id: "be", name: "Belarusian", nativeName: "беларуская" },
    { id: "be_BY", name: "Belarusian (Belarus)", nativeName: "беларуская (Беларусь)" },
    { id: "bn", name: "Bengali", nativeName: "বাংলা" },
    { id: "bn_BD", name: "Bengali (Bangladesh)", nativeName: "বাংলা (বাংলাদেশ)" },
    { id: "bn_IN", name: "Bengali (India)", nativeName: "বাংলা (ভারত)" },
    { id: "bs", name: "Bosnian", nativeName: "bosanski" },
    { id: "bs_BA", name: "Bosnian (Bosnia & Herzegovina)", nativeName: "bosanski (Bosna i Hercegovina)" },
    { id: "bs_Cyrl_BA", name: "Bosnian (Cyrillic, Bosnia & Herzegovina)", nativeName: "босански (Ћирилица, Босна и Херцеговина)" },
    { id: "bs_Cyrl", name: "Bosnian (Cyrillic)", nativeName: "босански (Ћирилица)" },
    { id: "bs_Latn_BA", name: "Bosnian (Latin, Bosnia & Herzegovina)", nativeName: "bosanski (latinica, Bosna i Hercegovina)" },
    { id: "bs_Latn", name: "Bosnian (Latin)", nativeName: "bosanski (latinica)" },
    { id: "br", name: "Breton", nativeName: "brezhoneg" },
    { id: "br_FR", name: "Breton (France)", nativeName: "brezhoneg (Frañs)" },
    { id: "bg", name: "Bulgarian", nativeName: "български" },
    { id: "bg_BG", name: "Bulgarian (Bulgaria)", nativeName: "български (България)" },
    { id: "my", name: "Burmese", nativeName: "ဗမာ" },
    { id: "my_MM", name: "Burmese (Myanmar (Burma))", nativeName: "ဗမာ (မြန်မာ)" },
    { id: "ca", name: "Catalan", nativeName: "català" },
    { id: "ca_AD", name: "Catalan (Andorra)", nativeName: "català (Andorra)" },
    { id: "ca_FR", name: "Catalan (France)", nativeName: "català (França)" },
    { id: "ca_IT", name: "Catalan (Italy)", nativeName: "català (Itàlia)" },
    { id: "ca_ES", name: "Catalan (Spain)", nativeName: "català (Espanya)" },
    { id: "zh", name: "Chinese", nativeName: "中文" },
    { id: "zh_CN", name: "Chinese (China)", nativeName: "中文 (中国)" },
    { id: "zh_HK", name: "Chinese (Hong Kong SAR China)", nativeName: "中文 (中国香港特别行政区)" },
    { id: "zh_MO", name: "Chinese (Macau SAR China)", nativeName: "中文 (中国澳门特别行政区)" },
    { id: "zh_Hans_CN", name: "Chinese (Simplified, China)", nativeName: "中文 (简体中文, 中国)" },
    { id: "zh_Hans_HK", name: "Chinese (Simplified, Hong Kong SAR China)", nativeName: "中文 (简体中文, 中国香港特别行政区)" },
    { id: "zh_Hans_MO", name: "Chinese (Simplified, Macau SAR China)", nativeName: "中文 (简体中文, 中国澳门特别行政区)" },
    { id: "zh_Hans_SG", name: "Chinese (Simplified, Singapore)", nativeName: "中文 (简体中文, 新加坡)" },
    { id: "zh_Hans", name: "Chinese (Simplified)", nativeName: "中文 (简体中文)" },
    { id: "zh_SG", name: "Chinese (Singapore)", nativeName: "中文 (新加坡)" },
    { id: "zh_TW", name: "Chinese (Taiwan)", nativeName: "中文 (台湾)" },
    { id: "zh_Hant_HK", name: "Chinese (Traditional, Hong Kong SAR China)", nativeName: "中文 (繁體字, 中華人民共和國香港特別行政區)" },
    { id: "zh_Hant_MO", name: "Chinese (Traditional, Macau SAR China)", nativeName: "中文 (繁體, 中華人民共和國澳門特別行政區)" },
    { id: "zh_Hant_TW", name: "Chinese (Traditional, Taiwan)", nativeName: "中文 (繁體, 台灣)" },
    { id: "zh_Hant", name: "Chinese (Traditional)", nativeName: "中文 (繁體)" },
    { id: "kw", name: "Cornish", nativeName: "kernewek" },
    { id: "kw_GB", name: "Cornish (United Kingdom)", nativeName: "kernewek (Rywvaneth Unys)" },
    { id: "hr", name: "Croatian", nativeName: "hrvatski" },
    { id: "hr_BA", name: "Croatian (Bosnia & Herzegovina)", nativeName: "hrvatski (Bosna i Hercegovina)" },
    { id: "hr_HR", name: "Croatian (Croatia)", nativeName: "hrvatski (Hrvatska)" },
    { id: "cs", name: "Czech", nativeName: "čeština" },
    { id: "cs_CZ", name: "Czech (Czech Republic)", nativeName: "čeština (Česká republika)" },
    { id: "da", name: "Danish", nativeName: "dansk" },
    { id: "da_DK", name: "Danish (Denmark)", nativeName: "dansk (Danmark)" },
    { id: "da_GL", name: "Danish (Greenland)", nativeName: "dansk (Grønland)" },
    { id: "nl", name: "Dutch", nativeName: "Nederlands" },
    { id: "nl_AW", name: "Dutch (Aruba)", nativeName: "Nederlands (Aruba)" },
    { id: "nl_BE", name: "Dutch (Belgium)", nativeName: "Nederlands (België)" },
    { id: "nl_BQ", name: "Dutch (Caribbean Netherlands)", nativeName: "Nederlands (Caribisch Nederland)" },
    { id: "nl_CW", name: "Dutch (Curaçao)", nativeName: "Nederlands (Curaçao)" },
    { id: "nl_NL", name: "Dutch (Netherlands)", nativeName: "Nederlands (Nederland)" },
    { id: "nl_SX", name: "Dutch (Sint Maarten)", nativeName: "Nederlands (Sint-Maarten)" },
    { id: "nl_SR", name: "Dutch (Suriname)", nativeName: "Nederlands (Suriname)" },
    { id: "dz", name: "Dzongkha", nativeName: "རྫོང་ཁ" },
    { id: "dz_BT", name: "Dzongkha (Bhutan)", nativeName: "རྫོང་ཁ (འབྲུག)" },
    { id: "en", name: "English", nativeName: "English" },
    { id: "en_AS", name: "English (American Samoa)", nativeName: "English (American Samoa)" },
    { id: "en_AI", name: "English (Anguilla)", nativeName: "English (Anguilla)" },
    { id: "en_AG", name: "English (Antigua & Barbuda)", nativeName: "English (Antigua & Barbuda)" },
    { id: "en_AU", name: "English (Australia)", nativeName: "English (Australia)" },
    { id: "en_BS", name: "English (Bahamas)", nativeName: "English (Bahamas)" },
    { id: "en_BB", name: "English (Barbados)", nativeName: "English (Barbados)" },
    { id: "en_BE", name: "English (Belgium)", nativeName: "English (Belgium)" },
    { id: "en_BZ", name: "English (Belize)", nativeName: "English (Belize)" },
    { id: "en_BM", name: "English (Bermuda)", nativeName: "English (Bermuda)" },
    { id: "en_BW", name: "English (Botswana)", nativeName: "English (Botswana)" },
    { id: "en_IO", name: "English (British Indian Ocean Territory)", nativeName: "English (British Indian Ocean Territory)" },
    { id: "en_VG", name: "English (British Virgin Islands)", nativeName: "English (British Virgin Islands)" },
    { id: "en_CM", name: "English (Cameroon)", nativeName: "English (Cameroon)" },
    { id: "en_CA", name: "English (Canada)", nativeName: "English (Canada)" },
    { id: "en_KY", name: "English (Cayman Islands)", nativeName: "English (Cayman Islands)" },
    { id: "en_CX", name: "English (Christmas Island)", nativeName: "English (Christmas Island)" },
    { id: "en_CC", name: "English (Cocos (Keeling) Islands)", nativeName: "English (Cocos (Keeling) Islands)" },
    { id: "en_CK", name: "English (Cook Islands)", nativeName: "English (Cook Islands)" },
    { id: "en_DG", name: "English (Diego Garcia)", nativeName: "English (Diego Garcia)" },
    { id: "en_DM", name: "English (Dominica)", nativeName: "English (Dominica)" },
    { id: "en_ER", name: "English (Eritrea)", nativeName: "English (Eritrea)" },
    { id: "en_FK", name: "English (Falkland Islands)", nativeName: "English (Falkland Islands)" },
    { id: "en_FJ", name: "English (Fiji)", nativeName: "English (Fiji)" },
    { id: "en_GM", name: "English (Gambia)", nativeName: "English (Gambia)" },
    { id: "en_GH", name: "English (Ghana)", nativeName: "English (Ghana)" },
    { id: "en_GI", name: "English (Gibraltar)", nativeName: "English (Gibraltar)" },
    { id: "en_GD", name: "English (Grenada)", nativeName: "English (Grenada)" },
    { id: "en_GU", name: "English (Guam)", nativeName: "English (Guam)" },
    { id: "en_GG", name: "English (Guernsey)", nativeName: "English (Guernsey)" },
    { id: "en_GY", name: "English (Guyana)", nativeName: "English (Guyana)" },
    { id: "en_HK", name: "English (Hong Kong SAR China)", nativeName: "English (Hong Kong SAR China)" },
    { id: "en_IN", name: "English (India)", nativeName: "English (India)" },
    { id: "en_IE", name: "English (Ireland)", nativeName: "English (Ireland)" },
    { id: "en_IM", name: "English (Isle of Man)", nativeName: "English (Isle of Man)" },
    { id: "en_JM", name: "English (Jamaica)", nativeName: "English (Jamaica)" },
    { id: "en_JE", name: "English (Jersey)", nativeName: "English (Jersey)" },
    { id: "en_KE", name: "English (Kenya)", nativeName: "English (Kenya)" },
    { id: "en_KI", name: "English (Kiribati)", nativeName: "English (Kiribati)" },
    { id: "en_LS", name: "English (Lesotho)", nativeName: "English (Lesotho)" },
    { id: "en_LR", name: "English (Liberia)", nativeName: "English (Liberia)" },
    { id: "en_MO", name: "English (Macau SAR China)", nativeName: "English (Macau SAR China)" },
    { id: "en_MG", name: "English (Madagascar)", nativeName: "English (Madagascar)" },
    { id: "en_MW", name: "English (Malawi)", nativeName: "English (Malawi)" },
    { id: "en_MY", name: "English (Malaysia)", nativeName: "English (Malaysia)" },
    { id: "en_MT", name: "English (Malta)", nativeName: "English (Malta)" },
    { id: "en_MH", name: "English (Marshall Islands)", nativeName: "English (Marshall Islands)" },
    { id: "en_MU", name: "English (Mauritius)", nativeName: "English (Mauritius)" },
    { id: "en_FM", name: "English (Micronesia)", nativeName: "English (Micronesia)" },
    { id: "en_MS", name: "English (Montserrat)", nativeName: "English (Montserrat)" },
    { id: "en_NA", name: "English (Namibia)", nativeName: "English (Namibia)" },
    { id: "en_NR", name: "English (Nauru)", nativeName: "English (Nauru)" },
    { id: "en_NZ", name: "English (New Zealand)", nativeName: "English (New Zealand)" },
    { id: "en_NG", name: "English (Nigeria)", nativeName: "English (Nigeria)" },
    { id: "en_NU", name: "English (Niue)", nativeName: "English (Niue)" },
    { id: "en_NF", name: "English (Norfolk Island)", nativeName: "English (Norfolk Island)" },
    { id: "en_MP", name: "English (Northern Mariana Islands)", nativeName: "English (Northern Mariana Islands)" },
    { id: "en_PK", name: "English (Pakistan)", nativeName: "English (Pakistan)" },
    { id: "en_PW", name: "English (Palau)", nativeName: "English (Palau)" },
    { id: "en_PG", name: "English (Papua New Guinea)", nativeName: "English (Papua New Guinea)" },
    { id: "en_PH", name: "English (Philippines)", nativeName: "English (Philippines)" },
    { id: "en_PN", name: "English (Pitcairn Islands)", nativeName: "English (Pitcairn Islands)" },
    { id: "en_PR", name: "English (Puerto Rico)", nativeName: "English (Puerto Rico)" },
    { id: "en_RW", name: "English (Rwanda)", nativeName: "English (Rwanda)" },
    { id: "en_WS", name: "English (Samoa)", nativeName: "English (Samoa)" },
    { id: "en_SC", name: "English (Seychelles)", nativeName: "English (Seychelles)" },
    { id: "en_SL", name: "English (Sierra Leone)", nativeName: "English (Sierra Leone)" },
    { id: "en_SG", name: "English (Singapore)", nativeName: "English (Singapore)" },
    { id: "en_SX", name: "English (Sint Maarten)", nativeName: "English (Sint Maarten)" },
    { id: "en_SB", name: "English (Solomon Islands)", nativeName: "English (Solomon Islands)" },
    { id: "en_ZA", name: "English (South Africa)", nativeName: "English (South Africa)" },
    { id: "en_SS", name: "English (South Sudan)", nativeName: "English (South Sudan)" },
    { id: "en_SH", name: "English (St. Helena)", nativeName: "English (St. Helena)" },
    { id: "en_KN", name: "English (St. Kitts & Nevis)", nativeName: "English (St. Kitts & Nevis)" },
    { id: "en_LC", name: "English (St. Lucia)", nativeName: "English (St. Lucia)" },
    { id: "en_VC", name: "English (St. Vincent & Grenadines)", nativeName: "English (St. Vincent & Grenadines)" },
    { id: "en_SD", name: "English (Sudan)", nativeName: "English (Sudan)" },
    { id: "en_SZ", name: "English (Swaziland)", nativeName: "English (Swaziland)" },
    { id: "en_TZ", name: "English (Tanzania)", nativeName: "English (Tanzania)" },
    { id: "en_TK", name: "English (Tokelau)", nativeName: "English (Tokelau)" },
    { id: "en_TO", name: "English (Tonga)", nativeName: "English (Tonga)" },
    { id: "en_TT", name: "English (Trinidad & Tobago)", nativeName: "English (Trinidad & Tobago)" },
    { id: "en_TC", name: "English (Turks & Caicos Islands)", nativeName: "English (Turks & Caicos Islands)" },
    { id: "en_TV", name: "English (Tuvalu)", nativeName: "English (Tuvalu)" },
    { id: "en_UM", name: "English (U.S. Outlying Islands)", nativeName: "English (U.S. Outlying Islands)" },
    { id: "en_VI", name: "English (U.S. Virgin Islands)", nativeName: "English (U.S. Virgin Islands)" },
    { id: "en_UG", name: "English (Uganda)", nativeName: "English (Uganda)" },
    { id: "en_GB", name: "English (United Kingdom)", nativeName: "English (United Kingdom)" },
    { id: "en_US", name: "English (United States)", nativeName: "English (United States)" },
    { id: "en_VU", name: "English (Vanuatu)", nativeName: "English (Vanuatu)" },
    { id: "en_ZM", name: "English (Zambia)", nativeName: "English (Zambia)" },
    { id: "en_ZW", name: "English (Zimbabwe)", nativeName: "English (Zimbabwe)" },
    { id: "eo", name: "Esperanto", nativeName: "esperanto" },
    { id: "et", name: "Estonian", nativeName: "eesti" },
    { id: "et_EE", name: "Estonian (Estonia)", nativeName: "eesti (Eesti)" },
    { id: "ee", name: "Ewe", nativeName: "eʋegbe" },
    { id: "ee_GH", name: "Ewe (Ghana)", nativeName: "eʋegbe (Ghana nutome)" },
    { id: "ee_TG", name: "Ewe (Togo)", nativeName: "eʋegbe (Togo nutome)" },
    { id: "fo", name: "Faroese", nativeName: "føroyskt" },
    { id: "fo_FO", name: "Faroese (Faroe Islands)", nativeName: "føroyskt (Føroyar)" },
    { id: "fi", name: "Finnish", nativeName: "suomi" },
    { id: "fi_FI", name: "Finnish (Finland)", nativeName: "suomi (Suomi)" },
    { id: "fr", name: "French", nativeName: "français" },
    { id: "fr_DZ", name: "French (Algeria)", nativeName: "français (Algérie)" },
    { id: "fr_BE", name: "French (Belgium)", nativeName: "français (Belgique)" },
    { id: "fr_BJ", name: "French (Benin)", nativeName: "français (Bénin)" },
    { id: "fr_BF", name: "French (Burkina Faso)", nativeName: "français (Burkina Faso)" },
    { id: "fr_BI", name: "French (Burundi)", nativeName: "français (Burundi)" },
    { id: "fr_CM", name: "French (Cameroon)", nativeName: "français (Cameroun)" },
    { id: "fr_CA", name: "French (Canada)", nativeName: "français (Canada)" },
    { id: "fr_CF", name: "French (Central African Republic)", nativeName: "français (République centrafricaine)" },
    { id: "fr_TD", name: "French (Chad)", nativeName: "français (Tchad)" },
    { id: "fr_KM", name: "French (Comoros)", nativeName: "français (Comores)" },
    { id: "fr_CG", name: "French (Congo - Brazzaville)", nativeName: "français (Congo-Brazzaville)" },
    { id: "fr_CD", name: "French (Congo - Kinshasa)", nativeName: "français (Congo-Kinshasa)" },
    { id: "fr_CI", name: "French (Côte d’Ivoire)", nativeName: "français (Côte d’Ivoire)" },
    { id: "fr_DJ", name: "French (Djibouti)", nativeName: "français (Djibouti)" },
    { id: "fr_GQ", name: "French (Equatorial Guinea)", nativeName: "français (Guinée équatoriale)" },
    { id: "fr_FR", name: "French (France)", nativeName: "français (France)" },
    { id: "fr_GF", name: "French (French Guiana)", nativeName: "français (Guyane française)" },
    { id: "fr_PF", name: "French (French Polynesia)", nativeName: "français (Polynésie française)" },
    { id: "fr_GA", name: "French (Gabon)", nativeName: "français (Gabon)" },
    { id: "fr_GP", name: "French (Guadeloupe)", nativeName: "français (Guadeloupe)" },
    { id: "fr_GN", name: "French (Guinea)", nativeName: "français (Guinée)" },
    { id: "fr_HT", name: "French (Haiti)", nativeName: "français (Haïti)" },
    { id: "fr_LU", name: "French (Luxembourg)", nativeName: "français (Luxembourg)" },
    { id: "fr_MG", name: "French (Madagascar)", nativeName: "français (Madagascar)" },
    { id: "fr_ML", name: "French (Mali)", nativeName: "français (Mali)" },
    { id: "fr_MQ", name: "French (Martinique)", nativeName: "français (Martinique)" },
    { id: "fr_MR", name: "French (Mauritania)", nativeName: "français (Mauritanie)" },
    { id: "fr_MU", name: "French (Mauritius)", nativeName: "français (Maurice)" },
    { id: "fr_YT", name: "French (Mayotte)", nativeName: "français (Mayotte)" },
    { id: "fr_MC", name: "French (Monaco)", nativeName: "français (Monaco)" },
    { id: "fr_MA", name: "French (Morocco)", nativeName: "français (Maroc)" },
    { id: "fr_NC", name: "French (New Caledonia)", nativeName: "français (Nouvelle-Calédonie)" },
    { id: "fr_NE", name: "French (Niger)", nativeName: "français (Niger)" },
    { id: "fr_RE", name: "French (Réunion)", nativeName: "français (La Réunion)" },
    { id: "fr_RW", name: "French (Rwanda)", nativeName: "français (Rwanda)" },
    { id: "fr_SN", name: "French (Senegal)", nativeName: "français (Sénégal)" },
    { id: "fr_SC", name: "French (Seychelles)", nativeName: "français (Seychelles)" },
    { id: "fr_BL", name: "French (St. Barthélemy)", nativeName: "français (Saint-Barthélemy)" },
    { id: "fr_MF", name: "French (St. Martin)", nativeName: "français (Saint-Martin (partie française))" },
    { id: "fr_PM", name: "French (St. Pierre & Miquelon)", nativeName: "français (Saint-Pierre-et-Miquelon)" },
    { id: "fr_CH", name: "French (Switzerland)", nativeName: "français (Suisse)" },
    { id: "fr_SY", name: "French (Syria)", nativeName: "français (Syrie)" },
    { id: "fr_TG", name: "French (Togo)", nativeName: "français (Togo)" },
    { id: "fr_TN", name: "French (Tunisia)", nativeName: "français (Tunisie)" },
    { id: "fr_VU", name: "French (Vanuatu)", nativeName: "français (Vanuatu)" },
    { id: "fr_WF", name: "French (Wallis & Futuna)", nativeName: "français (Wallis-et-Futuna)" },
    { id: "ff", name: "Fulah", nativeName: "Pulaar" },
    { id: "ff_CM", name: "Fulah (Cameroon)", nativeName: "Pulaar (Kameruun)" },
    { id: "ff_GN", name: "Fulah (Guinea)", nativeName: "Pulaar (Gine)" },
    { id: "ff_MR", name: "Fulah (Mauritania)", nativeName: "Pulaar (Muritani)" },
    { id: "ff_SN", name: "Fulah (Senegal)", nativeName: "Pulaar (Senegaal)" },
    { id: "gl", name: "Galician", nativeName: "galego" },
    { id: "gl_ES", name: "Galician (Spain)", nativeName: "galego (España)" },
    { id: "lg", name: "Ganda", nativeName: "Luganda" },
    { id: "lg_UG", name: "Ganda (Uganda)", nativeName: "Luganda (Yuganda)" },
    { id: "ka", name: "Georgian", nativeName: "ქართული" },
    { id: "ka_GE", name: "Georgian (Georgia)", nativeName: "ქართული (საქართველო)" },
    { id: "de", name: "German", nativeName: "Deutsch" },
    { id: "de_AT", name: "German (Austria)", nativeName: "Deutsch (Österreich)" },
    { id: "de_BE", name: "German (Belgium)", nativeName: "Deutsch (Belgien)" },
    { id: "de_DE", name: "German (Germany)", nativeName: "Deutsch (Deutschland)" },
    { id: "de_LI", name: "German (Liechtenstein)", nativeName: "Deutsch (Liechtenstein)" },
    { id: "de_LU", name: "German (Luxembourg)", nativeName: "Deutsch (Luxemburg)" },
    { id: "de_CH", name: "German (Switzerland)", nativeName: "Deutsch (Schweiz)" },
    { id: "el", name: "Greek", nativeName: "Ελληνικά" },
    { id: "el_CY", name: "Greek (Cyprus)", nativeName: "Ελληνικά (Κύπρος)" },
    { id: "el_GR", name: "Greek (Greece)", nativeName: "Ελληνικά (Ελλάδα)" },
    { id: "gu", name: "Gujarati", nativeName: "ગુજરાતી" },
    { id: "gu_IN", name: "Gujarati (India)", nativeName: "ગુજરાતી (ભારત)" },
    { id: "ha", name: "Hausa", nativeName: "Hausa" },
    { id: "ha_GH", name: "Hausa (Ghana)", nativeName: "Hausa (Gana)" },
    { id: "ha_Latn_GH", name: "Hausa (Latin, Ghana)", nativeName: "Hausa (Latin, Ghana)" },
    { id: "ha_Latn_NE", name: "Hausa (Latin, Niger)", nativeName: "Hausa (Latin, Niger)" },
    { id: "ha_Latn_NG", name: "Hausa (Latin, Nigeria)", nativeName: "Hausa (Latin, Nigeria)" },
    { id: "ha_Latn", name: "Hausa (Latin)", nativeName: "Hausa (Latin)" },
    { id: "ha_NE", name: "Hausa (Niger)", nativeName: "Hausa (Nijar)" },
    { id: "ha_NG", name: "Hausa (Nigeria)", nativeName: "Hausa (Najeriya)" },
    { id: "he", name: "Hebrew", nativeName: "עברית" },
    { id: "he_IL", name: "Hebrew (Israel)", nativeName: "עברית (ישראל)" },
    { id: "hi", name: "Hindi", nativeName: "हिंदी" },
    { id: "hi_IN", name: "Hindi (India)", nativeName: "हिंदी (भारत)" },
    { id: "hu", name: "Hungarian", nativeName: "magyar" },
    { id: "hu_HU", name: "Hungarian (Hungary)", nativeName: "magyar (Magyarország)" },
    { id: "is", name: "Icelandic", nativeName: "íslenska" },
    { id: "is_IS", name: "Icelandic (Iceland)", nativeName: "íslenska (Ísland)" },
    { id: "ig", name: "Igbo", nativeName: "Igbo" },
    { id: "ig_NG", name: "Igbo (Nigeria)", nativeName: "Igbo (Nigeria)" },
    { id: "id", name: "Indonesian", nativeName: "Bahasa Indonesia" },
    { id: "id_ID", name: "Indonesian (Indonesia)", nativeName: "Bahasa Indonesia (Indonesia)" },
    { id: "ga", name: "Irish", nativeName: "Gaeilge" },
    { id: "ga_IE", name: "Irish (Ireland)", nativeName: "Gaeilge (Éire)" },
    { id: "it", name: "Italian", nativeName: "italiano" },
    { id: "it_IT", name: "Italian (Italy)", nativeName: "italiano (Italia)" },
    { id: "it_SM", name: "Italian (San Marino)", nativeName: "italiano (San Marino)" },
    { id: "it_CH", name: "Italian (Switzerland)", nativeName: "italiano (Svizzera)" },
    { id: "ja", name: "Japanese", nativeName: "日本語" },
    { id: "ja_JP", name: "Japanese (Japan)", nativeName: "日本語 (日本)" },
    { id: "kl", name: "Kalaallisut", nativeName: "kalaallisut" },
    { id: "kl_GL", name: "Kalaallisut (Greenland)", nativeName: "kalaallisut (Kalaallit Nunaat)" },
    { id: "kn", name: "Kannada", nativeName: "ಕನ್ನಡ" },
    { id: "kn_IN", name: "Kannada (India)", nativeName: "ಕನ್ನಡ (ಭಾರತ)" },
    { id: "ks", name: "Kashmiri", nativeName: "کٲشُر" },
    { id: "ks_Arab_IN", name: "Kashmiri (Arabic, India)", nativeName: "کٲشُر (اَربی, ہِنٛدوستان)" },
    { id: "ks_Arab", name: "Kashmiri (Arabic)", nativeName: "کٲشُر (اَربی)" },
    { id: "ks_IN", name: "Kashmiri (India)", nativeName: "کٲشُر (ہِنٛدوستان)" },
    { id: "kk", name: "Kazakh", nativeName: "қазақ тілі" },
    { id: "kk_Cyrl_KZ", name: "Kazakh (Cyrillic, Kazakhstan)", nativeName: "қазақ тілі (кирилл жазуы, Қазақстан)" },
    { id: "kk_Cyrl", name: "Kazakh (Cyrillic)", nativeName: "қазақ тілі (кирилл жазуы)" },
    { id: "kk_KZ", name: "Kazakh (Kazakhstan)", nativeName: "қазақ тілі (Қазақстан)" },
    { id: "km", name: "Khmer", nativeName: "ខ្មែរ" },
    { id: "km_KH", name: "Khmer (Cambodia)", nativeName: "ខ្មែរ (កម្ពុជា)" },
    { id: "ki", name: "Kikuyu", nativeName: "Gikuyu" },
    { id: "ki_KE", name: "Kikuyu (Kenya)", nativeName: "Gikuyu (Kenya)" },
    { id: "rw", name: "Kinyarwanda", nativeName: "Kinyarwanda" },
    { id: "rw_RW", name: "Kinyarwanda (Rwanda)", nativeName: "Kinyarwanda (Rwanda)" },
    { id: "ko", name: "Korean", nativeName: "한국어" },
    { id: "ko_KP", name: "Korean (North Korea)", nativeName: "한국어 (조선 민주주의 인민 공화국)" },
    { id: "ko_KR", name: "Korean (South Korea)", nativeName: "한국어 (대한민국)" },
    { id: "ky", name: "Kyrgyz", nativeName: "кыргызча" },
    { id: "ky_Cyrl_KG", name: "Kyrgyz (Cyrillic, Kyrgyzstan)", nativeName: "кыргызча (Кирилик, Кыргызстан)" },
    { id: "ky_Cyrl", name: "Kyrgyz (Cyrillic)", nativeName: "кыргызча (Кирилик)" },
    { id: "ky_KG", name: "Kyrgyz (Kyrgyzstan)", nativeName: "кыргызча (Кыргызстан)" },
    { id: "lo", name: "Lao", nativeName: "ລາວ" },
    { id: "lo_LA", name: "Lao (Laos)", nativeName: "ລາວ (ລາວ)" },
    { id: "lv", name: "Latvian", nativeName: "latviešu" },
    { id: "lv_LV", name: "Latvian (Latvia)", nativeName: "latviešu (Latvija)" },
    { id: "ln", name: "Lingala", nativeName: "lingála" },
    { id: "ln_AO", name: "Lingala (Angola)", nativeName: "lingála (Angóla)" },
    { id: "ln_CF", name: "Lingala (Central African Republic)", nativeName: "lingála (Repibiki ya Afríka ya Káti)" },
    { id: "ln_CG", name: "Lingala (Congo - Brazzaville)", nativeName: "lingála (Kongo)" },
    { id: "ln_CD", name: "Lingala (Congo - Kinshasa)", nativeName: "lingála (Repibiki demokratiki ya Kongó)" },
    { id: "lt", name: "Lithuanian", nativeName: "lietuvių" },
    { id: "lt_LT", name: "Lithuanian (Lithuania)", nativeName: "lietuvių (Lietuva)" },
    { id: "lu", name: "Luba-Katanga", nativeName: "Tshiluba" },
    { id: "lu_CD", name: "Luba-Katanga (Congo - Kinshasa)", nativeName: "Tshiluba (Ditunga wa Kongu)" },
    { id: "lb", name: "Luxembourgish", nativeName: "Lëtzebuergesch" },
    { id: "lb_LU", name: "Luxembourgish (Luxembourg)", nativeName: "Lëtzebuergesch (Lëtzebuerg)" },
    { id: "mk", name: "Macedonian", nativeName: "македонски" },
    { id: "mk_MK", name: "Macedonian (Macedonia)", nativeName: "македонски (Македонија)" },
    { id: "mg", name: "Malagasy", nativeName: "Malagasy" },
    { id: "mg_MG", name: "Malagasy (Madagascar)", nativeName: "Malagasy (Madagasikara)" },
    { id: "ms", name: "Malay", nativeName: "Bahasa Melayu" },
    { id: "ms_BN", name: "Malay (Brunei)", nativeName: "Bahasa Melayu (Brunei)" },
    { id: "ms_Latn_BN", name: "Malay (Latin, Brunei)", nativeName: "Bahasa Melayu (Latin, Brunei)" },
    { id: "ms_Latn_MY", name: "Malay (Latin, Malaysia)", nativeName: "Bahasa Melayu (Latin, Malaysia)" },
    { id: "ms_Latn_SG", name: "Malay (Latin, Singapore)", nativeName: "Bahasa Melayu (Latin, Singapura)" },
    { id: "ms_Latn", name: "Malay (Latin)", nativeName: "Bahasa Melayu (Latin)" },
    { id: "ms_MY", name: "Malay (Malaysia)", nativeName: "Bahasa Melayu (Malaysia)" },
    { id: "ms_SG", name: "Malay (Singapore)", nativeName: "Bahasa Melayu (Singapura)" },
    { id: "ml", name: "Malayalam", nativeName: "മലയാളം" },
    { id: "ml_IN", name: "Malayalam (India)", nativeName: "മലയാളം (ഇന്ത്യ)" },
    { id: "mt", name: "Maltese", nativeName: "Malti" },
    { id: "mt_MT", name: "Maltese (Malta)", nativeName: "Malti (Malta)" },
    { id: "gv", name: "Manx", nativeName: "Gaelg" },
    { id: "gv_IM", name: "Manx (Isle of Man)", nativeName: "Gaelg (Ellan Vannin)" },
    { id: "mr", name: "Marathi", nativeName: "मराठी" },
    { id: "mr_IN", name: "Marathi (India)", nativeName: "मराठी (भारत)" },
    { id: "mn", name: "Mongolian", nativeName: "монгол" },
    { id: "mn_Cyrl_MN", name: "Mongolian (Cyrillic, Mongolia)", nativeName: "монгол (кирил, Монгол)" },
    { id: "mn_Cyrl", name: "Mongolian (Cyrillic)", nativeName: "монгол (кирил)" },
    { id: "mn_MN", name: "Mongolian (Mongolia)", nativeName: "монгол (Монгол)" },
    { id: "ne", name: "Nepali", nativeName: "नेपाली" },
    { id: "ne_IN", name: "Nepali (India)", nativeName: "नेपाली (भारत)" },
    { id: "ne_NP", name: "Nepali (Nepal)", nativeName: "नेपाली (नेपाल)" },
    { id: "nd", name: "North Ndebele", nativeName: "isiNdebele" },
    { id: "nd_ZW", name: "North Ndebele (Zimbabwe)", nativeName: "isiNdebele (Zimbabwe)" },
    { id: "se", name: "Northern Sami", nativeName: "davvisámegiella" },
    { id: "se_FI", name: "Northern Sami (Finland)", nativeName: "davvisámegiella (Suopma)" },
    { id: "se_NO", name: "Northern Sami (Norway)", nativeName: "davvisámegiella (Norga)" },
    { id: "se_SE", name: "Northern Sami (Sweden)", nativeName: "davvisámegiella (Ruoŧŧa)" },
    { id: "no", name: "Norwegian", nativeName: "Norwegian" },
    { id: "no_NO", name: "Norwegian (Norway)", nativeName: "Norwegian (Norway)" },
    { id: "nb", name: "Norwegian Bokmål", nativeName: "norsk bokmål" },
    { id: "nb_NO", name: "Norwegian Bokmål (Norway)", nativeName: "norsk bokmål (Norge)" },
    { id: "nb_SJ", name: "Norwegian Bokmål (Svalbard & Jan Mayen)", nativeName: "norsk bokmål (Svalbard og Jan Mayen)" },
    { id: "nn", name: "Norwegian Nynorsk", nativeName: "nynorsk" },
    { id: "nn_NO", name: "Norwegian Nynorsk (Norway)", nativeName: "nynorsk (Noreg)" },
    { id: "or", name: "Oriya", nativeName: "ଓଡ଼ିଆ" },
    { id: "or_IN", name: "Oriya (India)", nativeName: "ଓଡ଼ିଆ (ଭାରତ)" },
    { id: "om", name: "Oromo", nativeName: "Oromoo" },
    { id: "om_ET", name: "Oromo (Ethiopia)", nativeName: "Oromoo (Itoophiyaa)" },
    { id: "om_KE", name: "Oromo (Kenya)", nativeName: "Oromoo (Keeniyaa)" },
    { id: "os", name: "Ossetic", nativeName: "ирон" },
    { id: "os_GE", name: "Ossetic (Georgia)", nativeName: "ирон (Гуырдзыстон)" },
    { id: "os_RU", name: "Ossetic (Russia)", nativeName: "ирон (Уӕрӕсе)" },
    { id: "ps", name: "Pashto", nativeName: "پښتو" },
    { id: "ps_AF", name: "Pashto (Afghanistan)", nativeName: "پښتو (افغانستان)" },
    { id: "fa", name: "Persian", nativeName: "فارسی" },
    { id: "fa_AF", name: "Persian (Afghanistan)", nativeName: "دری (افغانستان)" },
    { id: "fa_IR", name: "Persian (Iran)", nativeName: "فارسی (ایران)" },
    { id: "pl", name: "Polish", nativeName: "polski" },
    { id: "pl_PL", name: "Polish (Poland)", nativeName: "polski (Polska)" },
    { id: "pt", name: "Portuguese", nativeName: "português" },
    { id: "pt_AO", name: "Portuguese (Angola)", nativeName: "português (Angola)" },
    { id: "pt_BR", name: "Portuguese (Brazil)", nativeName: "português (Brasil)" },
    { id: "pt_CV", name: "Portuguese (Cape Verde)", nativeName: "português (Cabo Verde)" },
    { id: "pt_GW", name: "Portuguese (Guinea-Bissau)", nativeName: "português (Guiné Bissau)" },
    { id: "pt_MO", name: "Portuguese (Macau SAR China)", nativeName: "português (Macau, RAE da China)" },
    { id: "pt_MZ", name: "Portuguese (Mozambique)", nativeName: "português (Moçambique)" },
    { id: "pt_PT", name: "Portuguese (Portugal)", nativeName: "português (Portugal)" },
    { id: "pt_ST", name: "Portuguese (São Tomé & Príncipe)", nativeName: "português (São Tomé e Príncipe)" },
    { id: "pt_TL", name: "Portuguese (Timor-Leste)", nativeName: "português (Timor-Leste)" },
    { id: "pa", name: "Punjabi", nativeName: "ਪੰਜਾਬੀ" },
    { id: "pa_Arab_PK", name: "Punjabi (Arabic, Pakistan)", nativeName: "پنجابی (عربی, پکستان)" },
    { id: "pa_Arab", name: "Punjabi (Arabic)", nativeName: "پنجابی (عربی)" },
    { id: "pa_Guru_IN", name: "Punjabi (Gurmukhi, India)", nativeName: "ਪੰਜਾਬੀ (ਗੁਰਮੁਖੀ, ਭਾਰਤ)" },
    { id: "pa_Guru", name: "Punjabi (Gurmukhi)", nativeName: "ਪੰਜਾਬੀ (ਗੁਰਮੁਖੀ)" },
    { id: "pa_IN", name: "Punjabi (India)", nativeName: "ਪੰਜਾਬੀ (ਭਾਰਤ)" },
    { id: "pa_PK", name: "Punjabi (Pakistan)", nativeName: "ਪੰਜਾਬੀ (ਪਾਕਿਸਤਾਨ)" },
    { id: "qu", name: "Quechua", nativeName: "Runasimi" },
    { id: "qu_BO", name: "Quechua (Bolivia)", nativeName: "Runasimi (Bolivia)" },
    { id: "qu_EC", name: "Quechua (Ecuador)", nativeName: "Runasimi (Ecuador)" },
    { id: "qu_PE", name: "Quechua (Peru)", nativeName: "Runasimi (Perú)" },
    { id: "ro", name: "Romanian", nativeName: "română" },
    { id: "ro_MD", name: "Romanian (Moldova)", nativeName: "română (Republica Moldova)" },
    { id: "ro_RO", name: "Romanian (Romania)", nativeName: "română (România)" },
    { id: "rm", name: "Romansh", nativeName: "rumantsch" },
    { id: "rm_CH", name: "Romansh (Switzerland)", nativeName: "rumantsch (Svizra)" },
    { id: "rn", name: "Rundi", nativeName: "Ikirundi" },
    { id: "rn_BI", name: "Rundi (Burundi)", nativeName: "Ikirundi (Uburundi)" },
    { id: "ru", name: "Russian", nativeName: "Русский" },
    { id: "ru_BY", name: "Russian (Belarus)", nativeName: "Русский (Беларусь)" },
    { id: "ru_KZ", name: "Russian (Kazakhstan)", nativeName: "Русский (Казахстан)" },
    { id: "ru_KG", name: "Russian (Kyrgyzstan)", nativeName: "Русский (Киргизия)" },
    { id: "ru_MD", name: "Russian (Moldova)", nativeName: "Русский (Молдова)" },
    { id: "ru_RU", name: "Russian (Russia)", nativeName: "Русский (Россия)" },
    { id: "ru_UA", name: "Russian (Ukraine)", nativeName: "Русский (Украина)" },
    { id: "sg", name: "Sango", nativeName: "Sängö" },
    { id: "sg_CF", name: "Sango (Central African Republic)", nativeName: "Sängö (Ködörösêse tî Bêafrîka)" },
    { id: "gd", name: "Scottish Gaelic", nativeName: "Gàidhlig" },
    { id: "gd_GB", name: "Scottish Gaelic (United Kingdom)", nativeName: "Gàidhlig (An Rìoghachd Aonaichte)" },
    { id: "sr", name: "Serbian", nativeName: "српски" },
    { id: "sr_BA", name: "Serbian (Bosnia & Herzegovina)", nativeName: "српски (Босна и Херцеговина)" },
    { id: "sr_Cyrl_BA", name: "Serbian (Cyrillic, Bosnia & Herzegovina)", nativeName: "српски (ћирилица, Босна и Херцеговина)" },
    { id: "sr_Cyrl_XK", name: "Serbian (Cyrillic, Kosovo)", nativeName: "српски (ћирилица, Косово)" },
    { id: "sr_Cyrl_ME", name: "Serbian (Cyrillic, Montenegro)", nativeName: "српски (ћирилица, Црна Гора)" },
    { id: "sr_Cyrl_RS", name: "Serbian (Cyrillic, Serbia)", nativeName: "српски (ћирилица, Србија)" },
    { id: "sr_Cyrl", name: "Serbian (Cyrillic)", nativeName: "српски (ћирилица)" },
    { id: "sr_XK", name: "Serbian (Kosovo)", nativeName: "српски (Косово)" },
    { id: "sr_Latn_BA", name: "Serbian (Latin, Bosnia & Herzegovina)", nativeName: "srpski (latinica, Bosna i Hercegovina)" },
    { id: "sr_Latn_XK", name: "Serbian (Latin, Kosovo)", nativeName: "srpski (latinica, Kosovo)" },
    { id: "sr_Latn_ME", name: "Serbian (Latin, Montenegro)", nativeName: "srpski (latinica, Crna Gora)" },
    { id: "sr_Latn_RS", name: "Serbian (Latin, Serbia)", nativeName: "srpski (latinica, Srbija)" },
    { id: "sr_Latn", name: "Serbian (Latin)", nativeName: "srpski (latinica)" },
    { id: "sr_ME", name: "Serbian (Montenegro)", nativeName: "српски (Црна Гора)" },
    { id: "sr_RS", name: "Serbian (Serbia)", nativeName: "српски (Србија)" },
    { id: "sh", name: "Serbo-Croatian", nativeName: "Serbo-Croatian" },
    { id: "sh_BA", name: "Serbo-Croatian (Bosnia & Herzegovina)", nativeName: "Serbo-Croatian (Bosnia & Herzegovina)" },
    { id: "sn", name: "Shona", nativeName: "chiShona" },
    { id: "sn_ZW", name: "Shona (Zimbabwe)", nativeName: "chiShona (Zimbabwe)" },
    { id: "ii", name: "Sichuan Yi", nativeName: "ꆈꌠꉙ" },
    { id: "ii_CN", name: "Sichuan Yi (China)", nativeName: "ꆈꌠꉙ (ꍏꇩ)" },
    { id: "si", name: "Sinhala", nativeName: "සිංහල" },
    { id: "si_LK", name: "Sinhala (Sri Lanka)", nativeName: "සිංහල (ශ්‍රී ලංකාව)" },
    { id: "sk", name: "Slovak", nativeName: "slovenčina" },
    { id: "sk_SK", name: "Slovak (Slovakia)", nativeName: "slovenčina (Slovensko)" },
    { id: "sl", name: "Slovenian", nativeName: "slovenščina" },
    { id: "sl_SI", name: "Slovenian (Slovenia)", nativeName: "slovenščina (Slovenija)" },
    { id: "so", name: "Somali", nativeName: "Soomaali" },
    { id: "so_DJ", name: "Somali (Djibouti)", nativeName: "Soomaali (Jabuuti)" },
    { id: "so_ET", name: "Somali (Ethiopia)", nativeName: "Soomaali (Itoobiya)" },
    { id: "so_KE", name: "Somali (Kenya)", nativeName: "Soomaali (Kiiniya)" },
    { id: "so_SO", name: "Somali (Somalia)", nativeName: "Soomaali (Soomaaliya)" },
    { id: "es", name: "Spanish", nativeName: "español" },
    { id: "es_AR", name: "Spanish (Argentina)", nativeName: "español (Argentina)" },
    { id: "es_BO", name: "Spanish (Bolivia)", nativeName: "español (Bolivia)" },
    { id: "es_IC", name: "Spanish (Canary Islands)", nativeName: "español (islas Canarias)" },
    { id: "es_EA", name: "Spanish (Ceuta & Melilla)", nativeName: "español (Ceuta y Melilla)" },
    { id: "es_CL", name: "Spanish (Chile)", nativeName: "español (Chile)" },
    { id: "es_CO", name: "Spanish (Colombia)", nativeName: "español (Colombia)" },
    { id: "es_CR", name: "Spanish (Costa Rica)", nativeName: "español (Costa Rica)" },
    { id: "es_CU", name: "Spanish (Cuba)", nativeName: "español (Cuba)" },
    { id: "es_DO", name: "Spanish (Dominican Republic)", nativeName: "español (República Dominicana)" },
    { id: "es_EC", name: "Spanish (Ecuador)", nativeName: "español (Ecuador)" },
    { id: "es_SV", name: "Spanish (El Salvador)", nativeName: "español (El Salvador)" },
    { id: "es_GQ", name: "Spanish (Equatorial Guinea)", nativeName: "español (Guinea Ecuatorial)" },
    { id: "es_GT", name: "Spanish (Guatemala)", nativeName: "español (Guatemala)" },
    { id: "es_HN", name: "Spanish (Honduras)", nativeName: "español (Honduras)" },
    { id: "es_MX", name: "Spanish (Mexico)", nativeName: "español (México)" },
    { id: "es_NI", name: "Spanish (Nicaragua)", nativeName: "español (Nicaragua)" },
    { id: "es_PA", name: "Spanish (Panama)", nativeName: "español (Panamá)" },
    { id: "es_PY", name: "Spanish (Paraguay)", nativeName: "español (Paraguay)" },
    { id: "es_PE", name: "Spanish (Peru)", nativeName: "español (Perú)" },
    { id: "es_PH", name: "Spanish (Philippines)", nativeName: "español (Filipinas)" },
    { id: "es_PR", name: "Spanish (Puerto Rico)", nativeName: "español (Puerto Rico)" },
    { id: "es_ES", name: "Spanish (Spain)", nativeName: "español (España)" },
    { id: "es_US", name: "Spanish (United States)", nativeName: "español (Estados Unidos)" },
    { id: "es_UY", name: "Spanish (Uruguay)", nativeName: "español (Uruguay)" },
    { id: "es_VE", name: "Spanish (Venezuela)", nativeName: "español (Venezuela)" },
    { id: "sw", name: "Swahili", nativeName: "Kiswahili" },
    { id: "sw_KE", name: "Swahili (Kenya)", nativeName: "Kiswahili (Kenya)" },
    { id: "sw_TZ", name: "Swahili (Tanzania)", nativeName: "Kiswahili (Tanzania)" },
    { id: "sw_UG", name: "Swahili (Uganda)", nativeName: "Kiswahili (Uganda)" },
    { id: "sv", name: "Swedish", nativeName: "svenska" },
    { id: "sv_AX", name: "Swedish (Åland Islands)", nativeName: "svenska (Åland)" },
    { id: "sv_FI", name: "Swedish (Finland)", nativeName: "svenska (Finland)" },
    { id: "sv_SE", name: "Swedish (Sweden)", nativeName: "svenska (Sverige)" },
    { id: "tl", name: "Tagalog", nativeName: "Tagalog" },
    { id: "tl_PH", name: "Tagalog (Philippines)", nativeName: "Tagalog (Philippines)" },
    { id: "ta", name: "Tamil", nativeName: "தமிழ்" },
    { id: "ta_IN", name: "Tamil (India)", nativeName: "தமிழ் (இந்தியா)" },
    { id: "ta_MY", name: "Tamil (Malaysia)", nativeName: "தமிழ் (மலேஷியா)" },
    { id: "ta_SG", name: "Tamil (Singapore)", nativeName: "தமிழ் (சிங்கப்பூர்)" },
    { id: "ta_LK", name: "Tamil (Sri Lanka)", nativeName: "தமிழ் (இலங்கை)" },
    { id: "te", name: "Telugu", nativeName: "తెలుగు" },
    { id: "te_IN", name: "Telugu (India)", nativeName: "తెలుగు (భారత దేశం)" },
    { id: "th", name: "Thai", nativeName: "ไทย" },
    { id: "th_TH", name: "Thai (Thailand)", nativeName: "ไทย (ไทย)" },
    { id: "bo", name: "Tibetan", nativeName: "བོད་སྐད་" },
    { id: "bo_CN", name: "Tibetan (China)", nativeName: "བོད་སྐད་ (རྒྱ་ནག)" },
    { id: "bo_IN", name: "Tibetan (India)", nativeName: "བོད་སྐད་ (རྒྱ་གར་)" },
    { id: "ti", name: "Tigrinya", nativeName: "ትግርኛ" },
    { id: "ti_ER", name: "Tigrinya (Eritrea)", nativeName: "Tigrinya (Eritrea)" },
    { id: "ti_ET", name: "Tigrinya (Ethiopia)", nativeName: "Tigrinya (Ethiopia)" },
    { id: "to", name: "Tongan", nativeName: "lea fakatonga" },
    { id: "to_TO", name: "Tongan (Tonga)", nativeName: "lea fakatonga (Tonga)" },
    { id: "tr", name: "Turkish", nativeName: "Türkçe" },
    { id: "tr_CY", name: "Turkish (Cyprus)", nativeName: "Türkçe (Güney Kıbrıs Rum Kesimi)" },
    { id: "tr_TR", name: "Turkish (Turkey)", nativeName: "Türkçe (Türkiye)" },
    { id: "uk", name: "Ukrainian", nativeName: "українська" },
    { id: "uk_UA", name: "Ukrainian (Ukraine)", nativeName: "українська (Україна)" },
    { id: "ur", name: "Urdu", nativeName: "اردو" },
    { id: "ur_IN", name: "Urdu (India)", nativeName: "اردو (بھارت)" },
    { id: "ur_PK", name: "Urdu (Pakistan)", nativeName: "اردو (پاکستان)" },
    { id: "ug", name: "Uyghur", nativeName: "ئۇيغۇرچە" },
    { id: "ug_Arab_CN", name: "Uyghur (Arabic, China)", nativeName: "ئۇيغۇرچە (ئەرەب, جۇڭگو)" },
    { id: "ug_Arab", name: "Uyghur (Arabic)", nativeName: "ئۇيغۇرچە (ئەرەب)" },
    { id: "ug_CN", name: "Uyghur (China)", nativeName: "ئۇيغۇرچە (جۇڭگو)" },
    { id: "uz", name: "Uzbek", nativeName: "oʻzbekcha" },
    { id: "uz_AF", name: "Uzbek (Afghanistan)", nativeName: "oʻzbekcha (Afgʻoniston)" },
    { id: "uz_Arab_AF", name: "Uzbek (Arabic, Afghanistan)", nativeName: "اوزبیک (عربی, افغانستان)" },
    { id: "uz_Arab", name: "Uzbek (Arabic)", nativeName: "اوزبیک (عربی)" },
    { id: "uz_Cyrl_UZ", name: "Uzbek (Cyrillic, Uzbekistan)", nativeName: "Ўзбек (Кирил, Ўзбекистон)" },
    { id: "uz_Cyrl", name: "Uzbek (Cyrillic)", nativeName: "Ўзбек (Кирил)" },
    { id: "uz_Latn_UZ", name: "Uzbek (Latin, Uzbekistan)", nativeName: "oʻzbekcha (Lotin, Oʻzbekiston)" },
    { id: "uz_Latn", name: "Uzbek (Latin)", nativeName: "oʻzbekcha (Lotin)" },
    { id: "uz_UZ", name: "Uzbek (Uzbekistan)", nativeName: "oʻzbekcha (Oʻzbekiston)" },
    { id: "vi", name: "Vietnamese", nativeName: "Tiếng Việt" },
    { id: "vi_VN", name: "Vietnamese (Vietnam)", nativeName: "Tiếng Việt (Việt Nam)" },
    { id: "cy", name: "Welsh", nativeName: "Cymraeg" },
    { id: "cy_GB", name: "Welsh (United Kingdom)", nativeName: "Cymraeg (Y Deyrnas Unedig)" },
    { id: "fy", name: "Western Frisian", nativeName: "West-Frysk" },
    { id: "fy_NL", name: "Western Frisian (Netherlands)", nativeName: "West-Frysk (Nederlân)" },
    { id: "yi", name: "Yiddish", nativeName: "ייִדיש" },
    { id: "yo", name: "Yoruba", nativeName: "Èdè Yorùbá" },
    { id: "yo_BJ", name: "Yoruba (Benin)", nativeName: "Èdè Yorùbá (Orílɛ́ède Bɛ̀nɛ̀)" },
    { id: "yo_NG", name: "Yoruba (Nigeria)", nativeName: "Èdè Yorùbá (Orílẹ́ède Nàìjíríà)" },
    { id: "zu", name: "Zulu", nativeName: "isiZulu" },
    { id: "zu_ZA", name: "Zulu (South Africa)", nativeName: "isiZulu (i-South Africa)" }
            ];
        }
    };
});
